import styled from "styled-components";

export const ProductContainer = styled.div`
  width: 375px;
  padding-bottom: 25px;
  max-height: 90vh;
  overflow-y: auto; /* Enable vertical scrolling */
  border: 2px solid transparent;
  border-radius: var(--border-radius);
  transition: all var(--duration-short) ease-in-out;

  &.multiProductContainer {
    border: 2px solid var(--color-primary);
  }

  .ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: 1px solid #d9e1e2;
  }

  .ant-tabs-nav {
    margin: 0;
  }

  .ant-tabs-nav-list {
    display: flex;
    justify-content: center;
    padding: 0 25px;
  }

  .ant-tabs-tab .ant-tabs-tab-btn {
    font-weight: bold;
    font-size: 1.4rem;
    padding: 0 0px;
    margin: 0;
  }
`;

export const ProductButton = styled.button`
  position: relative;
  border-radius: var(--border-radius);
  color: var(--color-text);
  background-color: unset;
  font-weight: var(--fontWeightMedium);
  font-size: 12px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: none;
  cursor: pointer;
  padding: 0;
  gap: 5px;
  min-height: 80px;

  &.isMultiProduct.isSelected {
    padding-top: 8px;
  }

  &.isSelected {
    background: rgba(var(--color-shadow-rgb), 0.3);
    color: var(--color-primary);

    svg {
      color: var(--color-primary);
    }
  }

  span {
    margin-top: 0;
    word-wrap: normal;
    /* pre-line, so the line break the BOE label carries is rendered rather than
       collapsed into a space. Without it every product name still wraps on width
       alone, which is what leaves the shorter BOE names on one line. */
    white-space: pre-line;
  }

  .label {
    line-height: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
  }

  svg {
    color: var(--color-icon);
    transition: color var(--duration-short);
  }

  &:hover {
    background: rgba(var(--color-shadow-rgb), 0.3);

    svg {
      color: var(--color-primary);
    }
  }

  &.isSelected:hover {
    background: rgba(var(--color-shadow-rgb), 0.9);

    svg {
      color: var(--color-primary);
    }
  }

  &.isDisabled {
    pointer-events: auto;
    cursor: not-allowed;
    color: #ccc;
    opacity: 0.5;

    &:hover svg {
      color: var(--color-icon);
    }
  }

  &:hover .ps-indicator-btn {
    opacity: 1;
  }
`;
